import { useTranslation } from 'react-i18next';

import type { KeyboardEvent, MouseEvent } from 'react';

import styles from '@/components/CardPartner/styles.module.css';

interface CardPartnerAccessTileProps {
  link: string;
  isDisabled: boolean;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLAnchorElement>) => void;
}

const CardPartnerAccessTile = ({ link, isDisabled, onClick, onKeyDown }: CardPartnerAccessTileProps) => {
  const { t } = useTranslation();

  const content = (
    <>
      <span className={styles.tileLabel}>{t('partnerInfo.cardLinkLabel')}</span>
      <i className={`totem-icon totem-icon-external-link ${styles.tileIcon}`} />
    </>
  );

  // Désactivé : ni lien, ni focus, ni réaction au clic
  if (isDisabled) {
    return (
      <span className={`${styles.tile} ${styles.tileDisabled}`} aria-disabled="true">
        {content}
      </span>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer noopener"
      className={styles.tile}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {content}
    </a>
  );
};

export default CardPartnerAccessTile;
